import React from 'react';

import { CustomPaletteField } from './CustomPaletteField/CustomPaletteField';
import { useStyles } from './useStyles';

const CustomPaletteForm = (props) => {
    const { declaration, informationForm, onEditInformationField } = props;

    const classes = useStyles();

    return (
        <div className={classes.form}>
            {declaration.map(({ id, ...rest }) => (
                <CustomPaletteField
                    {...rest}
                    key={`${informationForm[id]}:${id}`}
                    id={id}
                    onChange={onEditInformationField}
                    informationForm={informationForm[id]}
                    defaultValue={informationForm[id]}
                />
            ))}
        </div>
    );
};

const CustomPaletteFormMemoized = React.memo(CustomPaletteForm);

export { CustomPaletteFormMemoized as CustomPaletteForm };
